import { CampaignMaterialActionsAssetCardController } from './campaign-material-actions-asset-card.controller'

function campaignMaterialActionsAssetCard () {
  return {
    scope: {
      campaign: '<',
      selectedMaterials: '<',
      material: '<',
      disabled: '<'
    },
    restrict: 'E',
    templateUrl: '/campaigns/directives/campaign-material-actions-asset-card/campaign-material-actions-asset-card.html?$$REVISION$$',
    controller: CampaignMaterialActionsAssetCardController
  }
}

export { campaignMaterialActionsAssetCard }
